import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { PlayerService } from '../../../@shared/services/player.service'
import { ModeEnum } from '@core/enums'

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.sass'],
  standalone: true,
})
export class TimerComponent implements OnChanges {
  constructor(private _playerService: PlayerService) {}

  @Input() countdown: number

  duration: number
  progress: number
  progressOffset: number
  radius = 22
  circumference = 2 * Math.PI * this.radius

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['countdown']) {
      if (this.duration === undefined) {
        this.duration = this.countdown
      }
      this.updateProgress()
    }
  }

  updateProgress(): void {
    this.progress = 1 - this.countdown / this.duration
    this.progressOffset = this.circumference * this.progress
  }
}
